import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Marcus T.',
  location: 'Austin, Texas'
}, {
  name: 'Jordan R.',
  location: 'Miami, Florida'
}, {
  name: 'Daniel K.',
  location: 'San Diego, California'
}, {
  name: 'Sofia M.',
  location: 'Denver, Colorado'
}, {
  name: 'Chris B.',
  location: 'Chicago, Illinois'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    let dismissTimer: number | undefined;
    function showPopup() {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      dismissTimer = window.setTimeout(() => setVisible(false), 6500);
    }
    const initialTimer = window.setTimeout(showPopup, 3200);
    const interval = window.setInterval(showPopup, 18000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
      if (dismissTimer) window.clearTimeout(dismissTimer);
    };
  }, []);
  if (!visible) return null;
  return <aside className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex justify-center animate-slide-in sm:left-auto sm:right-4 sm:justify-end" aria-live="polite" data-id="element-174" data-mp="22mf18r5ztwwb">
      <div className="pointer-events-auto relative w-full max-w-[304px] border-2 border-white bg-brand-lime p-2.5 pr-8 text-brand-coal shadow-[5px_5px_0_#111111]" data-id="element-175" data-mp="1sqlhampy314i">
        <button type="button" onClick={() => setVisible(false)} aria-label="Close purchase notification" className="absolute right-1.5 top-1.5 rounded p-0.5 text-brand-coal/70 transition hover:text-brand-coal focus:outline-none focus:ring-2 focus:ring-brand-coal" data-id="element-176" data-mp="2lehlechufvbb">
          <XIcon className="h-4 w-4" data-id="element-177" data-mp="14zzgngi9sj4j" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-178" data-mp="151kg9kjfys99">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center border-2 border-brand-coal bg-white" data-id="element-179" data-mp="10y4gwgfzmdsv">
            <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-180" data-mp="12gutzv19mbe5" />
          </div>
          <div className="leading-tight" data-id="element-181" data-mp="17f62a1bwwdu9">
            <p className="text-xs font-extrabold" data-id="element-182" data-mp="17e4ovq7fbf9d">{currentPurchase.name}</p>
            <p className="text-[10px] font-semibold text-brand-coal/75" data-id="element-183" data-mp="sgu41q8w4x0z">{currentPurchase.location}, United States</p>
            <p className="mt-0.5 text-[11px] font-extrabold uppercase" data-id="element-184" data-mp="xevn4b6bgwcg">just purchased this digital book</p>
          </div>
        </div>
      </div>
    </aside>;
}